














import { defineComponent, SetupContext } from '@vue/composition-api';
import VEditorGroupItem from '@/components/editor/group/VEditorGroupItem.vue';
import FormatAlignLeft from 'vue-material-design-icons/FormatAlignLeft.vue';
import FormatAlignRight from 'vue-material-design-icons/FormatAlignRight.vue';
import FormatAlignCenter from 'vue-material-design-icons/FormatAlignCenter.vue';
import FormatAlignJustify from 'vue-material-design-icons/FormatAlignJustify.vue';
import FormatListBulleted from 'vue-material-design-icons/FormatListBulleted.vue';
import FormatListNumbered from 'vue-material-design-icons/FormatListNumbered.vue';
import { CommandsItem } from '@/@types/index';

const useClickHandle = (emit: SetupContext['emit']) => {
  const onClick = (rule: CommandsItem) => {
    emit('changeCommand', rule);
  };

  return { onClick };
};

export default defineComponent({
  components: {
    VEditorGroupItem,
    FormatAlignLeft,
    FormatAlignRight,
    FormatAlignCenter,
    FormatAlignJustify,
    FormatListBulleted,
    FormatListNumbered,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    selected: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    const { onClick } = useClickHandle(emit);

    return { onClick };
  },
});
